import './WalletBalance.scss'
import { useSelector } from 'react-redux'
import { getPrecision, numberWithCommas } from 'helpers/common.helpers'
import { CURRENCY_SYMBOL } from 'constants/index'
import { useTranslation } from 'react-i18next'

const WalletBalance = () => {
  const { t } = useTranslation()
  const { userInfo, demoMode, demoWallet } = useSelector((state) => state.auth)
  const selectedWallet = demoMode ? demoWallet : userInfo?.wallet
  const balance = selectedWallet?.balance || 0
  const currencyCode = demoMode ? demoWallet?.currency : selectedWallet?.currency

  return (
    <span className='d-grid d-lg-flex justify-content-center wallet-border'>
      <strong className='balance-label'>{t('BALANCE')}: </strong>&nbsp;{CURRENCY_SYMBOL[currencyCode]} {numberWithCommas(getPrecision(balance))}
    </span>
  )
}

export default WalletBalance
